(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutech-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(scope = document) {
      scope.querySelectorAll('[data-nutech-finder]:not([data-initialized])').forEach(root => {
        root.dataset.initialized = 'true';
        const data = JSON.parse(root.querySelector('[data-vehicle-data]').textContent);
        const form = root.querySelector('[data-finder]');
        if (!form) return;
        const makeSelect = form.elements.make, modelSelect = form.elements.model, yearInput = form.elements.year;
        const years = new Set();
        const currentYear = Number(root.dataset.currentYear);
        data.makes.forEach(make => make.models.forEach(model => model.generations.forEach(generation => {
          if (!generation.start) return;
          const lastYear = generation.end || currentYear;
          for (let year = generation.start; year <= lastYear; year++) years.add(year);
        })));
        Array.from(years).sort((a,b) => b-a).forEach(year => yearInput.add(new Option(String(year), String(year))));
        const message = root.querySelector('[data-message]');
        const categoryMode = root.dataset.categoryMode === 'true';
        const selectedModel = () => data.makes.find(make => make.key === makeSelect.value)?.models.find(model => model.key === modelSelect.value);
        const destination = (model, year) => {
          const url = new URL(categoryMode ? model.collection : model.page, window.location.origin);
          if (year) url.searchParams.set('vehicle_year', year);
          return url.pathname + url.search;
        };
        function updateModels() {
          modelSelect.replaceChildren(new Option(data.text.chooseModel, ''));
          const make = data.makes.find(item => item.key === makeSelect.value);
          (make?.models || []).slice().sort((a, b) => a.name.localeCompare(b.name, undefined, {numeric: true})).forEach(model => modelSelect.add(new Option(model.name, model.key)));
          modelSelect.disabled = !make;
          message.hidden = true;
        }
        makeSelect.addEventListener('change', updateModels);
        modelSelect.addEventListener('change', () => { message.hidden = true; });
        yearInput.addEventListener('change', () => { message.hidden = true; });
        if (root.dataset.currentMake) { makeSelect.value = root.dataset.currentMake; updateModels(); }
        if (root.dataset.currentModel) modelSelect.value = root.dataset.currentModel;
        const incoming = new URLSearchParams(window.location.search).get('vehicle_year');
        if (incoming && /^\d{4}$/.test(incoming)) yearInput.value = incoming;
        const matches = (model, year) => model.generations.filter(g => g.start && Number(year) >= g.start && (!g.end || Number(year) <= g.end));
        function showMessage(text, model) {
          message.replaceChildren(document.createTextNode(text));
          const link = document.createElement('a');
          link.href = destination(model, ''); link.textContent = data.text.browseAnyway;
          message.append(link); message.hidden = false;
        }
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const model = selectedModel();
          if (!model) return;
          const year = yearInput.value;
          if (year && !matches(model, year).length) {
            showMessage(model.generations.some(g => !g.start) ? data.text.unknown : data.text.noMatch, model);
            return;
          }
          window.location.assign(destination(model, year));
        });
        if (incoming && selectedModel()) {
          const found = matches(selectedModel(), incoming), selection = root.querySelector('[data-selection]');
          selection.textContent = found.length ? incoming + ' · ' + data.text.matches + ' ' + found.map(g => g.label).join(' / ') + '. ' + data.text.verify : data.text.noMatch;
          selection.hidden = false;
          if (found.length) (root.closest('main') || document).querySelectorAll('[data-result-link]').forEach(link => {
            const url = new URL(link.href); url.searchParams.set('vehicle_year', incoming); link.href = url.pathname + url.search + url.hash;
          });
        }
        form.hidden = false;
      });
    }
    init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
